<template lang="pug">
    p No settings available.
</template>

<script>
export default {
    methods: {
        resetErrors() {},
        resetPayment() {},
        submit() {},
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/setting/payment/custom/empty-form.vue